import * as Sentry from '@sentry/react';
import { addCompleteContextToSentry } from '../contexts/sentryContext';

export function handleResourceError(event: ErrorEvent): void {
  const target = event.target as HTMLElement;
  
  if (target && (target.tagName === 'IMG' || target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
    Sentry.withScope((scope) => {
      scope.setTag('errorType', 'resourceLoadError');
      scope.setLevel('warning');

      scope.setContext('resourceError', {
        tagName: target.tagName,
        src: (target as any).src || (target as any).href,
        timestamp: new Date().toISOString()
      });

      addCompleteContextToSentry(scope);
      Sentry.captureMessage(`Resource load error: ${target.tagName}`, 'warning');
    });
  }
}

